import React from 'react';
import i18n from 'i18next';
import { useBackDismiss } from 'hooks/useBackDismiss';
import styles from './Confirm.module.css';

/** 클래스 이름을 해시된 이름으로 바꿉니다. 모르는 이름은 그대로 둡니다.
 *  이름을 바꾸지 않고 스코프만 씌우려고 둔 얇은 헬퍼입니다. */
const cls = (names?: string): string =>
    (names || '').split(' ').filter(Boolean)
        .map((n) => (styles as Record<string, string>)[n] || n).join(' ');

interface ConfirmProps {
    isOpen: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const Confirm: React.FC<ConfirmProps> = ({
    isOpen,
    title = i18n.t('common.confirm'),
    message,
    confirmText = i18n.t('common.confirm'),
    cancelText = i18n.t('common.cancel'),
    onConfirm,
    onCancel
}) => {
    useBackDismiss(isOpen, onCancel);
    if (!isOpen) return null;

    return (
        <div className={cls("confirm-overlay")} onClick={onCancel}>
            <div className={cls("confirm-container")} onClick={(e) => e.stopPropagation()}>
                <div className={cls("confirm-content")}>
                    <h3 className={cls("confirm-title")}>{title}</h3>
                    <p className={cls("confirm-message")}>{message}</p>
                </div>
                <div className={cls("confirm-footer")}>
                    <button className={cls("confirm-button cancel")} onClick={onCancel}>
                        {cancelText}
                    </button>
                    <button className={cls("confirm-button confirm")} onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
